import Message from './Message';
import {
	getFromStore,
	storeInitChatAction,
	StorePath,
	useStoreActionsFromStore,
} from '../../services/store.service';
import MessageModel from '../../models/message.model';
import {useEffect, useRef} from 'react';
import Disclaimer from '../common/Disclaimer';
import {Settings} from '../../models/snippet-payload.model';
import DepartmentSelection from './Department-selection';
import AgentTypingIndicator from './Agent-typing-indicator';

const MessageList = () => {
	const messageListRef = useRef<HTMLDivElement | null>(null);
	const messages = getFromStore(StorePath.MESSAGES) as MessageModel[];
	const isAgentTyping = getFromStore(StorePath.AGENT_TYPING) as boolean;
	const initMsgStoreAction = useStoreActionsFromStore(storeInitChatAction);
	const departmentSelection = (getFromStore(StorePath.SETTINGS) as Settings)?.gpt_settings?.department_selection.is_enabled;

	useEffect(() => {
		if (messageListRef.current?.parentElement) {
			messageListRef.current.parentElement.scrollTo({
				top: messageListRef.current.parentElement.scrollHeight,
				behavior: 'smooth',
			});
		}
		if (!messages.length) {
			initMsgStoreAction();
		}
	}, [messages, isAgentTyping]);


	return (
		<div ref={messageListRef}>
			<Disclaimer/>
            {messages.map((message: MessageModel, index: number) => (
              <div key={index}>
                  <Message data={message}/>
                  {departmentSelection && !index && <DepartmentSelection />}
              </div>
            ))}
            {isAgentTyping && <AgentTypingIndicator />}
		</div>
	);
};

export default MessageList;
